(function () {
  var DEFAULT_HANDLE = 'luxe-racer-stripe-tall-pant';
  // Hardcoded fallback: used only if the default product's public JSON isn't
  // reachable yet (e.g. it's still in Draft status). Once it's published,
  // the fetch above succeeds and this constant is never used — remove it
  // once the default product is live, or update it if the default changes.
  var DEFAULT_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0695/8261/8724/files/RacerOlive5.png?v=1789384867';

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function applyImage(img, src) {
    if (!src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }

  function fetchProductImage(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.json')
      .then(function (response) {
        if (!response.ok) throw new Error('Product lookup failed');
        return response.json();
      })
      .then(function (data) {
        return data.product && data.product.image && data.product.image.src;
      });
  }

  function run() {
    var img = document.querySelector('[id^="shopify-section-"][id$="__membership_payback"] img');
    if (!img) return;

    var handle = getParam('handle');
    if (!handle) {
      try {
        handle = localStorage.getItem('crazytall_resume_handle');
      } catch (e) {
        /* localStorage unavailable — ignore */
      }
    }
    if (!handle) handle = DEFAULT_HANDLE;

    fetchProductImage(handle)
      .then(function (src) {
        applyImage(img, src);
      })
      .catch(function () {
        if (handle === DEFAULT_HANDLE) {
          applyImage(img, DEFAULT_IMAGE_URL);
          return;
        }
        fetchProductImage(DEFAULT_HANDLE)
          .then(function (src) {
            applyImage(img, src);
          })
          .catch(function () {
            applyImage(img, DEFAULT_IMAGE_URL);
          });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
